var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
export const Eyebrow = React.forwardRef((_a, ref) => {
    var { children, className, el: EyebrowElement = 'span', inline, italic, bold, size = 'medium' } = _a, props = __rest(_a, ["children", "className", "el", "inline", "italic", "bold", "size"]);
    const TextClasses = classnames('Eyebrow', className, {
        [`Eyebrow--${size}`]: size,
        'd-i': inline,
        'd-b': !inline,
        'fw-bold': bold,
        'fs-italic': italic,
        'fs-normal': !italic && italic != null,
    });
    return (React.createElement(EyebrowElement, Object.assign({ ref: ref, className: TextClasses }, props), children));
});
//# sourceMappingURL=Eyebrow.js.map